import { CreditCard, QrCode, Sparkles } from 'lucide-react';

interface PaymentMethodSelectorProps {
  selectedMethod: 'qr' | 'card';
  onMethodChange: (method: 'qr' | 'card') => void;
  disabled?: boolean;
}

export default function PaymentMethodSelector({ 
  selectedMethod, 
  onMethodChange,
  disabled = false 
}: PaymentMethodSelectorProps) {
  return (
    <div className="space-y-3">
      <h2 className="text-xl font-bold text-gray-900 mb-4">เลือกวิธีการชำระเงิน</h2>
      
      {/* QR PromptPay - Active */}
      <button
        type="button"
        onClick={() => !disabled && onMethodChange('qr')}
        disabled={disabled}
        className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
          selectedMethod === 'qr'
            ? 'border-blue-600 bg-blue-50 shadow-md'
            : 'border-gray-300 hover:border-blue-400 hover:bg-gray-50'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
              selectedMethod === 'qr' ? 'bg-blue-600' : 'bg-gray-400'
            }`}>
              <QrCode className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className={`font-bold text-lg ${
                selectedMethod === 'qr' ? 'text-blue-900' : 'text-gray-900'
              }`}>
                QR PromptPay
              </p>
              <p className="text-sm text-gray-600">สแกนจ่าย ยืนยันอัตโนมัติทันที</p>
              <div className="flex items-center gap-2 mt-1">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 text-xs font-semibold rounded-full">
                  <Sparkles className="w-3 h-3" />
                  Auto-verify
                </span>
                <span className="inline-flex items-center px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full">
                  แนะนำ
                </span>
              </div>
            </div>
          </div>
          <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
            selectedMethod === 'qr' ? 'border-blue-600' : 'border-gray-300'
          }`}>
            {selectedMethod === 'qr' && (
              <div className="w-3.5 h-3.5 rounded-full bg-blue-600"></div>
            )}
          </div>
        </div>
      </button>

      {/* Credit Card - Coming Soon */}
      <div className="relative">
        <button
          type="button"
          disabled
          className="w-full p-4 rounded-xl border-2 border-gray-200 bg-gray-50 text-left cursor-not-allowed opacity-60"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center">
                <CreditCard className="w-6 h-6 text-gray-500" />
              </div>
              <div>
                <p className="font-bold text-lg text-gray-700">บัตรเครดิต/เดบิต</p>
                <p className="text-sm text-gray-500">Visa, Mastercard, JCB</p>
                <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full mt-1">
                  <Sparkles className="w-3 h-3" />
                  เร็วๆ นี้
                </span>
              </div>
            </div>
            <div className="w-6 h-6 rounded-full border-2 border-gray-300"></div>
          </div>
        </button>
        
        {/* Coming Soon Badge */}
        <div className="absolute top-2 right-2">
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
            COMING SOON
          </div>
        </div>
      </div>

      {/* Info Box */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mt-4">
        <p className="text-xs text-blue-800">
          <span className="font-semibold">💡 เคล็ดลับ:</span> ใช้ QR PromptPay เพื่อรับการยืนยันอัตโนมัติทันที ไม่ต้องรอ Admin อนุมัติ
        </p>
      </div>
    </div>
  );
}
